import {
  faCancel,
  faCheck,
  faClock,
  faClose,
  faHourglassStart,
  faPlay,
  faReplyAll,
  faRoad,
  faThumbsUp,
  faTicket,
  faTruck,
  faUsd,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { translateOrderState } from '../../../utils/translate'

function classNames(...classes: string[]) {
  return classes.filter(Boolean)?.join(' ') ?? ' '
}

const getColorStatus = (value: string | null) => {
  switch (value) {
    case 'ACTIVE':
    case 'COMPLETED':
    case 'DELIVERED':
    case 'PAID':
    case 'BILLED':
    case 'ACCEPTED':
    case 'WAREHOUSE_RECEIVED':
    case 'EMPTY_RETURNED':
      return 'bg-green-100 text-green-800'

    case 'CLOSED':
      return 'bg-gray-200 text-gray-800'

    case 'REFUNDED':
      return 'bg-violet-200 text-violet-800'

    case 'CANCELLED':
      return 'bg-red-200 text-red-800'

    case 'OVERDUE':
      return 'bg-[#feccaa] text-[#9a4a12]'

    case 'CREATED':
      return 'bg-[#bfd7fe] text-[#1e55af]'

    case 'IN_PROCESS':
    case 'PROCESSED':
    case 'ORIGIN_RECEIVED':
    case 'DESTINY_ARRIVED':
    case 'BORDER_RELEASED':
      return 'bg-blue-100 text-blue-800'

    case 'DELIVERY_ASSIGNED':
    case 'IN_TRANSIT':
    case 'INTERNATIONAL_TRANSIT':
    case 'NATIONAL_TRANSIT':
      return 'bg-orange-100 text-orange-800'

    case 'READY_TO_TRANSPORT':
    case 'READY_TO_EMPTY_RETURN':
      return 'bg-yellow-100 text-yellow-800'

    default:
      return 'bg-yellow-100 text-yellow-800'
  }
}

const getStatusIcon = (status: string) => {
  switch (status) {
    case 'ACTIVE':
    case 'COMPLETED':
    case 'DELIVERED':
    case 'WAREHOUSE_RECEIVED':
    case 'EMPTY_RETURNED':
      return faCheck

    case 'CLOSED':
      return faClose

    case 'CANCELLED':
      return faCancel

    case 'OVERDUE':
      return faClock

    case 'IN_PROCESS':
    case 'WAITING':
    case 'ORIGIN_RECEIVED':
    case 'DESTINY_ARRIVED':
    case 'BORDER_RELEASED':
      return faHourglassStart

    case 'PROCESSED':
      return faPlay

    case 'DELIVERY_ASSIGNED':
    case 'READY_TO_TRANSPORT':
    case 'READY_TO_EMPTY_RETURN':
      return faTruck

    case 'ACCEPTED':
      return faThumbsUp

    case 'IN_TRANSIT':
    case 'INTERNATIONAL_TRANSIT':
    case 'NATIONAL_TRANSIT':
      return faRoad

    case 'REFUNDED':
      return faReplyAll

    case 'PAYMENT_PENDING':
      return faTicket

    case 'BILLED':
      return faUsd

    case 'CREATED':
      return faCheck

    default:
      return faCheck
  }
}

interface OrderStatusBadge {
  status?: string
  showIcon?: boolean
  onlyShowIcon?: boolean
  className?: string
}

export default function OrderStatusBadge({
  status,
  showIcon = true,
  onlyShowIcon,
  className = '',
}: OrderStatusBadge) {
  if (!status) return <></>
  return (
    <div
      className={classNames(
        getColorStatus(status),
        'inline-flex flex-shrink-0 items-center rounded-full px-2.5 py-0.5 text-sm font-medium md:mt-2 lg:mt-0',
        className
      )}
    >
      {showIcon && (
        <FontAwesomeIcon
          icon={getStatusIcon(status)}
          className={classNames(
            getColorStatus(status),
            'mr-2 flex-shrink-0 align-middle'
          )}
        />
      )}
      {!onlyShowIcon && (
        <span className="min-w-0 truncate">{translateOrderState(status)}</span>
      )}
    </div>
  )
}
